import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=3c051a97&"
import script from "./ArrowIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports